import React from "react";
import PatternOverlay from "@/components/PatternOverlay";

export default function JournalPage() {
  return (
    <div className="pattern-bg w-full" data-testid="journal-page">
      <PatternOverlay opacity={0.09} size={520} />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-32 text-center">
        <div className="text-xs uppercase tracking-[0.32em] text-primary">Le Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl mt-4 tracking-tight leading-[1.02]">
          The correspondence,{" "}
          <span className="italic text-primary">forthcoming</span>.
        </h1>
        <p className="mt-8 text-muted-foreground leading-relaxed max-w-xl mx-auto">
          Notes from the perfumer, layering rituals, letters from our travels,
          and previews of forthcoming releases. Our journal opens shortly —
          subscribe below to be the first to read.
        </p>
      </div>
    </div>
  );
}
